import { HugeiconsIcon } from '@hugeicons/react'
import {
  Building03Icon,
  InformationCircleIcon,
  RunningShoesIcon,
  Sun03Icon,
} from '@hugeicons/core-free-icons'

import { useAppStore } from '@/store'
import { cn } from '@/lib/utils'

const ITEMS = [
  { tool: 'residences', icon: Building03Icon, label: 'Homes' },
  { tool: 'walk', icon: RunningShoesIcon, label: 'Walk' },
  { tool: 'time', icon: Sun03Icon, label: 'Time' },
  { tool: 'info', icon: InformationCircleIcon, label: 'Info' },
] as const

// Phone chrome. The magnifying dock is a desktop surface (it needs a mouse to
// magnify and is hidden below sm), so without this bar a phone had no controls
// at all after the port. Leaner than Tower's MobileBar on purpose: four tools
// and the register CTA, no sheets.
export function MobileBar() {
  const tool = useAppStore((s) => s.tool)
  const toggleTool = useAppStore((s) => s.toggleTool)
  const enterWalk = useAppStore((s) => s.enterWalk)
  const walking = useAppStore((s) => s.walking)
  const setRegisterOpen = useAppStore((s) => s.setRegisterOpen)

  if (walking) return null

  return (
    <nav className="glass-pill pointer-events-auto fixed inset-x-3 bottom-3 z-50 flex items-center justify-between gap-1 px-2 py-1.5 sm:hidden">
      {ITEMS.map((item) => {
        const active = tool === item.tool
        return (
          <button
            key={item.label}
            type="button"
            onClick={() => (item.tool === 'walk' ? enterWalk() : toggleTool(item.tool))}
            aria-pressed={active}
            className={cn(
              'rounded-control flex min-w-14 cursor-pointer flex-col items-center gap-0.5 px-2 py-1.5 text-[10px] font-medium transition-colors',
              active ? 'bg-primary text-primary-foreground' : 'text-foreground/70',
            )}
          >
            <HugeiconsIcon icon={item.icon} size={17} strokeWidth={2} />
            {item.label}
          </button>
        )
      })}
      <button
        type="button"
        onClick={() => setRegisterOpen(true)}
        className="bg-primary text-primary-foreground rounded-control cursor-pointer px-3 py-2 text-xs font-semibold"
      >
        Register
      </button>
    </nav>
  )
}
